export default function MUIPortal() {
  return {};
}
